import { IS_DEMO } from "@/lib/api";

export default function DemoBanner() {
  if (!IS_DEMO) return null;

  return (
    <div
      className="bg-[#1a1d29] text-white text-center text-xs py-2 px-4 tracking-wide"
      data-testid="demo-mode-banner"
    >
      <span className="font-semibold uppercase tracking-[0.14em] text-[#c8532e]">Demo Mode</span>
      {" · "}
      Static preview — no live server. Cart, checkout &amp; admin work in your browser only.
    </div>
  );
}
